// import React, { useState, useEffect } from 'react';
// import {
//   FiPlus,
//   FiSearch,
//   FiX,
//   FiChevronLeft,
//   FiChevronRight,
//   FiCheckCircle,
//   FiAlertCircle,
//   FiEdit,
//   FiSave,
//   FiActivity,
//   FiArchive,
//   FiLayers,
//   FiPackage,
//   FiFilter
// } from 'react-icons/fi';
// import { useDispatch, useSelector } from 'react-redux';
// import { GetAllFabricType, AddFabricType, UpdateFabricType, GetAllInactiveFabricType } from '../actions/fabricTypeAction';

// function FabricTypes() {
//   const dispatch = useDispatch();

//   // Redux selectors
//   const fabricTypeList = useSelector((state) => state.fabricTypeList || {});
//   const { loading, responseBody: activeFabrics = [] } = fabricTypeList;

//   const fabricTypeAdd = useSelector((state) => state.fabricTypeAdd || {});
//   const { loading: adding, error: addError, msg: addMsg } = fabricTypeAdd;

//   const fabricTypeUpdate = useSelector((state) => state.fabricTypeUpdate || {});
//   const { loading: updating, error: updateError, msg: updateMsg } = fabricTypeUpdate;

//   const InactiveFabricTypeData = useSelector((state) => state.InactiveFabricTypeData || {});
//   const { loading: loadingInactive, responseBody: inactiveFabrics = [] } = InactiveFabricTypeData;

//   // State management
//   const [search, setSearch] = useState('');
//   const [showModal, setShowModal] = useState(false);
//   const [fabricName, setFabricName] = useState('');
//   const [stock, setStock] = useState('');
//   const [formError, setFormError] = useState('');
//   const [notification, setNotification] = useState(null);
  
//   // State for editing
//   const [editingId, setEditingId] = useState(null);
//   const [editName, setEditName] = useState('');
//   const [editStock, setEditStock] = useState('');
//   const [editStatus, setEditStatus] = useState('A');
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [editingFabric, setEditingFabric] = useState(null);

//   // Stock filter state
//   const [stockFilter, setStockFilter] = useState('all'); // 'all', 'out', 'low', 'good'

//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(8);

//   // Fetch both active and inactive fabrics
//   useEffect(() => {
//     dispatch(GetAllFabricType());
//     dispatch(GetAllInactiveFabricType({}));
//   }, [dispatch]);

//   // Show success/error toast after add or update
//   useEffect(() => {
//     if (!adding && (addMsg || addError)) {
//       if (addError) {
//         setNotification({ type: 'error', message: addError || 'Failed to add fabric type!' });
//       } else if (addMsg) {
//         setNotification({ type: 'success', message: addMsg || 'Fabric type added successfully!' });
//         setShowModal(false);
//         setFabricName('');
//         setStock('');
//         dispatch(GetAllFabricType());
//         dispatch(GetAllInactiveFabricType({}));
//       }
//       const timer = setTimeout(() => setNotification(null), 1500);
//       return () => clearTimeout(timer);
//     }
//   }, [addMsg, addError, adding, dispatch]);

//   useEffect(() => {
//     if (!updating && (updateMsg || updateError)) {
//       if (updateError) {
//         setNotification({ type: 'error', message: updateError || 'Failed to update fabric type!' });
//       } else if (updateMsg) {
//         setNotification({ type: 'success', message: updateMsg || 'Fabric type updated successfully!' });
//         setShowEditModal(false);
//         setEditingId(null);
//         setEditName('');
//         setEditStock('');
//         setEditStatus('A');
//         setEditingFabric(null);
//         dispatch(GetAllFabricType());
//         dispatch(GetAllInactiveFabricType({}));
//       }
//       const timer = setTimeout(() => setNotification(null), 1500);
//       return () => clearTimeout(timer);
//     }
//   }, [updateMsg, updateError, updating, dispatch]);

//   // Combine active and inactive fabrics for display and sort in descending order
//   const allFabrics = [
//     ...(Array.isArray(activeFabrics) ? activeFabrics.map(fab => ({ ...fab, status: 'A' })) : []),
//     ...(Array.isArray(inactiveFabrics) ? inactiveFabrics.map(fab => ({ ...fab, status: 'I' })) : [])
//   ].sort((a, b) => {
//     // Sort by FabricTypeId in descending order (newest first)
//     return (b.FabricTypeId || 0) - (a.FabricTypeId || 0);
//   });

//   // Get stock status and category for filtering
//   const getStockCategory = (stock) => {
//     const stockValue = parseInt(stock) || 0;
    
//     if (stockValue === 0) {
//       return 'out';
//     } else if (stockValue <= 10) {
//       return 'low';
//     } else {
//       return 'good';
//     }
//   };

//   // Handle add fabric type with duplicate check
//   const handleAddFabric = (e) => {
//     e.preventDefault();
//     const name = fabricName.trim();
//     if (!name) {
//       setFormError('Please enter a fabric name');
//       return;
//     }

//     const exists = allFabrics.some(
//       (f) => f.FabricTypeName.toLowerCase() === name.toLowerCase()
//     );
//     if (exists) {
//       setNotification({ type: 'error', message: 'Fabric type already exists!' });
//       setTimeout(() => setNotification(null), 1500);
//       return;
//     }

//     // Validate stock
//     const stockValue = parseInt(stock);
//     if (isNaN(stockValue) || stockValue < 0) {
//       setFormError('Please enter a valid stock quantity (0 or positive number)');
//       return;
//     }

//     setFormError('');
//     dispatch(AddFabricType({ 
//       FabricTypeName: name,
//       Stock: stockValue
//     }));
//   };

//   // Handle edit fabric type - Open modal
//   const handleEditClick = (fabric) => {
//     setEditingFabric(fabric);
//     setEditName(fabric.FabricTypeName);
//     setEditStock(fabric.Stock || '');
//     setEditStatus(fabric.status || fabric.Status || 'A');
//     setShowEditModal(true);
//   };

//   // Handle save edited fabric type
//   const handleSaveEdit = (e) => {
//     e.preventDefault();
    
//     if (!editingFabric) return;

//     const name = editName.trim();
//     if (!name) {
//       setNotification({ type: 'error', message: 'Please enter a fabric name' });
//       setTimeout(() => setNotification(null), 1500);
//       return;
//     }

//     // Validate stock
//     const stockValue = parseInt(editStock);
//     if (isNaN(stockValue) || stockValue < 0) {
//       setNotification({ type: 'error', message: 'Please enter a valid stock quantity (0 or positive number)' });
//       setTimeout(() => setNotification(null), 1500);
//       return;
//     }

//     const exists = allFabrics.some(
//       (f) => 
//         f.FabricTypeId !== editingFabric.FabricTypeId && 
//         f.FabricTypeName.toLowerCase() === name.toLowerCase()
//     );
//     if (exists) {
//       setNotification({ type: 'error', message: 'Fabric type already exists!' });
//       setTimeout(() => setNotification(null), 1500);
//       return;
//     }

//     const updateData = {
//       FabricTypeId: editingFabric.FabricTypeId,
//       FabricTypeName: name,
//       Stock: stockValue,
//       Status: editStatus
//     };

//     console.log('Sending update data:', updateData); // Debug log
//     dispatch(UpdateFabricType(updateData));
//   };

//   // Handle cancel edit
//   const handleCancelEdit = () => {
//     setShowEditModal(false);
//     setEditingFabric(null);
//     setEditName('');
//     setEditStock('');
//     setEditStatus('A');
//   };

//   // Get status display text and color
//   const getStatusInfo = (fabric) => {
//     const status = fabric.status || fabric.Status;
//     const isActive = status === 'A' || !status;
    
//     if (isActive) {
//       return { 
//         text: 'Active', 
//         color: 'bg-gradient-to-br from-green-500 to-green-600 text-white shadow-lg shadow-green-200/50',
//         icon: <FiCheckCircle className="mr-1" size={12} />
//       };
//     } else {
//       return { 
//         text: 'Inactive', 
//         color: 'bg-gradient-to-br from-slate-500 to-slate-600 text-white shadow-lg shadow-slate-200/50',
//         icon: <FiArchive className="mr-1" size={12} />
//       };
//     }
//   };

//   // Get row styling based on status
//   const getRowClass = (fabric) => {
//     const status = fabric.status || fabric.Status;
//     const isActive = status === 'A' || !status;
    
//     return isActive 
//       ? 'hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 bg-gradient-to-r from-white to-green-50/30 border-l-4 border-l-green-400' 
//       : 'hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 bg-gradient-to-r from-white to-slate-50/30 border-l-4 border-l-slate-300';
//   };

//   // Filter fabrics based on search and stock filter
//   const filteredFabrics = allFabrics.filter((f) => {
//     const matchesSearch = (f.FabricTypeName || '').toLowerCase().includes(search.toLowerCase());
//     const stockCategory = getStockCategory(f.Stock);
    
//     if (stockFilter === 'all') {
//       return matchesSearch;
//     } else {
//       return matchesSearch && stockCategory === stockFilter;
//     }
//   });

//   // Pagination logic
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentFabrics = filteredFabrics.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredFabrics.length / itemsPerPage);

//   // Pagination 3-page sliding window
//   const pageNumbers = [];
//   const maxPageButtons = 3;
//   let startPage = Math.max(1, currentPage - 1);
//   let endPage = Math.min(totalPages, startPage + maxPageButtons - 1);
//   if (endPage - startPage + 1 < maxPageButtons) {
//     startPage = Math.max(1, endPage - maxPageButtons + 1);
//   }
//   for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);

//   // Get count by stock category
//   const stockCounts = {
//     all: allFabrics.length,
//     out: allFabrics.filter(f => getStockCategory(f.Stock) === 'out').length,
//     low: allFabrics.filter(f => getStockCategory(f.Stock) === 'low').length,
//     good: allFabrics.filter(f => getStockCategory(f.Stock) === 'good').length,
//   };

//   // Loading state
//   const isLoading = loading || loadingInactive;

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-100/30 p-4 md:p-6 relative overflow-hidden">
//       {/* 3D Background Elements */}
//       <div className="absolute top-0 left-0 w-72 h-72 bg-gradient-to-r from-blue-400/20 to-purple-500/20 rounded-full -translate-x-1/2 -translate-y-1/2 opacity-40 blur-3xl"></div>
//       <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-r from-blue-400/20 to-cyan-500/20 rounded-full translate-x-1/3 translate-y-1/3 opacity-40 blur-3xl"></div>
      
//       {/* 3D Notification */}
//       {notification && (
//         <div
//           className={`fixed top-6 right-6 z-[100] p-4 rounded-2xl shadow-2xl flex items-center transition-all duration-500 transform backdrop-blur-none ${
//             notification.type === 'success' 
//               ? 'bg-gradient-to-r from-green-500 to-green-600 text-white shadow-green-200/50 border-l-4 border-l-green-400' 
//               : notification.type === 'error'
//               ? 'bg-gradient-to-r from-rose-500 to-red-600 text-white shadow-rose-200/50 border-l-4 border-l-rose-400'
//               : 'bg-gradient-to-r from-blue-500 to-cyan-600 text-white shadow-blue-200/50 border-l-4 border-l-blue-400'
//           } animate-bounce-in`}
//           role="alert"
//         >
//           <div className="bg-white/20 p-2 rounded-full mr-3 backdrop-blur-sm">
//             {notification.type === 'success' ? (
//               <FiCheckCircle className="text-white" size={18} />
//             ) : notification.type === 'error' ? (
//               <FiAlertCircle className="text-white" size={18} />
//             ) : (
//               <FiActivity className="text-white" size={18} />
//             )}
//           </div>
//           <span className="font-semibold text-sm">{notification.message}</span>
//         </div>
//       )}

//       {/* Header Section with 3D Effect */}
//       <div className="relative z-10 mb-6 md:mb-8">
//         <div className="flex items-center space-x-4 mb-3">
//           <div className="p-3 md:p-4 bg-gradient-to-br from-blue-800 to-blue-900 rounded-2xl shadow-2xl transform ">
//             <FiLayers className="text-white text-lg md:text-xl" />
//           </div>
//           <div className="transform ">
//             <h1 className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">
//               Fabric Types
//             </h1>
//             <p className="text-slate-600 mt-1 text-sm md:text-base">Manage your fabric inventory</p>
//           </div>
//         </div>
//       </div>

//       {/* 3D Stats Cards - Added Out of Stock card */}
//       <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-6 mb-6 md:mb-8 relative z-10">
//         <div className="group relative">
//           <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-blue-800 rounded-3xl blur opacity-20 group-hover:opacity-30 transition duration-300 transform group-hover:scale-105"></div>
//           <div className="relative bg-white/90 backdrop-blur-sm p-4 md:p-6 rounded-3xl shadow-2xl border border-white/20 transform transition duration-300 group-hover:-translate-y-2 group-hover:shadow-3xl">
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-slate-600 text-sm font-medium">Total Types</p>
//                 <p className="text-xl md:text-2xl font-bold text-slate-800">
//                   {allFabrics.length}
//                 </p>
//               </div>
//               <div className="p-2 md:p-3 bg-gradient-to-br from-blue-700 to-blue-800 rounded-2xl shadow-lg">
//                 <FiLayers className="text-white text-base md:text-lg" />
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="group relative">
//           <div className="absolute inset-0 bg-gradient-to-r from-red-500 to-red-700 rounded-3xl blur opacity-20 group-hover:opacity-30 transition duration-300 transform group-hover:scale-105"></div>
//           <div className="relative bg-white/90 backdrop-blur-sm p-4 md:p-6 rounded-3xl shadow-2xl border border-white/20 transform transition duration-300 group-hover:-translate-y-2 group-hover:shadow-3xl">
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-slate-600 text-sm font-medium">Out of Stock</p>
//                 <p className="text-xl md:text-2xl font-bold text-slate-800">
//                   {stockCounts.out}
//                 </p>
//               </div>
//               <div className="p-2 md:p-3 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl shadow-lg">
//                 <FiAlertCircle className="text-white text-base md:text-lg" />
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="group relative">
//           <div className="absolute inset-0 bg-gradient-to-r from-yellow-500 to-yellow-600 rounded-3xl blur opacity-20 group-hover:opacity-30 transition duration-300 transform group-hover:scale-105"></div>
//           <div className="relative bg-white/90 backdrop-blur-sm p-4 md:p-6 rounded-3xl shadow-2xl border border-white/20 transform transition duration-300 group-hover:-translate-y-2 group-hover:shadow-3xl">
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-slate-600 text-sm font-medium">Low Stock</p>
//                 <p className="text-xl md:text-2xl font-bold text-slate-800">
//                   {stockCounts.low}
//                 </p>
//               </div>
//               <div className="p-2 md:p-3 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl shadow-lg">
//                 <FiAlertCircle className="text-white text-base md:text-lg" />
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="group relative">
//           <div className="absolute inset-0 bg-gradient-to-r from-green-500 to-green-700 rounded-3xl blur opacity-20 group-hover:opacity-30 transition duration-300 transform group-hover:scale-105"></div>
//           <div className="relative bg-white/90 backdrop-blur-sm p-4 md:p-6 rounded-3xl shadow-2xl border border-white/20 transform transition duration-300 group-hover:-translate-y-2 group-hover:shadow-3xl">
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-slate-600 text-sm font-medium">Good Stock</p>
//                 <p className="text-xl md:text-2xl font-bold text-slate-800">
//                   {stockCounts.good}
//                 </p>
//               </div>
//               <div className="p-2 md:p-3 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl shadow-lg">
//                 <FiCheckCircle className="text-white text-base md:text-lg" />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Search + Filter + Add button - 3D Design */}
//       <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-4 mb-6 md:mb-8">
//         <div className="flex flex-col md:flex-row flex-grow space-y-4 md:space-y-0 md:space-x-4 w-full">
//           <div className="relative flex-grow group">
//             <div className="absolute inset-0 bg-gradient-to-r from-slate-400 to-slate-600 rounded-2xl blur opacity-20 group-hover:opacity-30 transition duration-300 transform group-hover:scale-105"></div>
//             <input
//               type="text"
//               placeholder="Search fabric types..."
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               className="relative w-full pl-10 sm:pl-12 pr-4 sm:pr-6 py-2.5 sm:py-3.5 border-0 bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl focus:outline-none focus:ring-2 sm:focus:ring-4 focus:ring-blue-200 text-slate-700 placeholder-slate-500 font-medium transition-all duration-300 text-sm sm:text-base"
//               disabled={isLoading}
//             />
//             <FiSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 z-10" size={18} />
//           </div>
          
//           {/* Stock Filter */}
//           <div className="relative group">
//             <div className="absolute inset-0 bg-gradient-to-r from-slate-500 to-slate-700 rounded-2xl blur opacity-20 group-hover:opacity-30 transition duration-300 transform group-hover:scale-105"></div>
//             <div className="relative flex items-center bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl px-3 py-2.5 sm:py-3.5">
//               <FiFilter className="text-slate-400 mr-2" size={16} />
//               <select
//                 value={stockFilter}
//                 onChange={(e) => setStockFilter(e.target.value)}
//                 className="bg-transparent border-0 focus:outline-none focus:ring-0 text-slate-700 font-medium text-sm sm:text-base appearance-none cursor-pointer"
//               >
//                 <option value="all">All Stock</option>
//                 <option value="out">Out of Stock</option>
//                 <option value="low">Low Stock (1-10)</option>
//                 <option value="good">Good Stock (11+)</option>
//               </select>
//             </div>
//           </div>

//           <button
//             onClick={() => setShowModal(true)}
//             className="relative group bg-gradient-to-br from-blue-800 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold px-6 py-3 md:py-3.5 rounded-2xl flex items-center justify-center shadow-2xl transition-all duration-300 transform hover:scale-105 hover:shadow-3xl active:scale-95 w-full md:w-auto"
//           >
//             <div className="absolute inset-0 bg-white/10 rounded-2xl transform group-hover:scale-110 transition duration-300"></div>
//             <FiPlus className="mr-2 relative z-10" size={18} /> 
//             <span className="relative z-10">Add Fabric Type</span>
//           </button>
//         </div>
//       </div>

//       {/* 3D Table */}
//       {isLoading ? (
//         <div className="relative z-10 text-center py-12">
//           <div className="inline-flex items-center space-x-3 bg-white/90 backdrop-blur-sm p-6 rounded-2xl shadow-2xl border border-white/20">
//             <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-800"></div>
//             <span className="text-slate-700">Loading fabric types...</span>
//           </div>
//         </div>
//       ) : (
//         <div className="relative z-10 overflow-hidden rounded-3xl shadow-2xl border border-white/20 bg-white/90 backdrop-blur-sm">
//           <div className="overflow-x-auto">
//             <table className="w-full min-w-[700px]">
//               <thead>
//                 <tr className="bg-gradient-to-r from-slate-50 to-slate-100/80 border-b border-slate-200/50">
//                   <th className="py-3 md:py-4 px-4 md:px-6 text-left text-slate-700 font-semibold text-xs md:text-sm uppercase tracking-wider">Fabric ID</th>
//                   <th className="py-3 md:py-4 px-4 md:px-6 text-left text-slate-700 font-semibold text-xs md:text-sm uppercase tracking-wider">Fabric Type</th>
//                   <th className="py-3 md:py-4 px-4 md:px-6 text-center text-slate-700 font-semibold text-xs md:text-sm uppercase tracking-wider">Stock</th>
//                   <th className="py-3 md:py-4 px-4 md:px-6 text-center text-slate-700 font-semibold text-xs md:text-sm uppercase tracking-wider">Status</th>
//                   <th className="py-3 md:py-4 px-4 md:px-6 text-center text-slate-700 font-semibold text-xs md:text-sm uppercase tracking-wider">Actions</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-slate-200/50">
//                 {currentFabrics.length > 0 ? (
//                   currentFabrics.map((f, i) => {
//                     const statusInfo = getStatusInfo(f);
//                     const rowClass = getRowClass(f);
//                     const stockValue = parseInt(f.Stock) || 0;
                    
//                     return (
//                       <tr key={f.FabricTypeId || i} className={`${rowClass} group`}>
//                         <td className="px-3 sm:px-4 md:px-6 py-3 sm:py-4 text-slate-600 text-sm sm:text-base max-w-[200px] truncate">
//                           {f.FabricTypeId || 'N/A'}
//                         </td>
//                         <td className="px-3 sm:px-4 md:px-6 py-3 sm:py-4 text-slate-600 text-sm sm:text-base max-w-[200px] truncate">
//                           <div className="flex items-center">
//                             <span className="text-slate-800 text-sm md:text-base">
//                               {f.FabricTypeName}
//                             </span>
//                           </div>
//                         </td>
//                         <td className="py-3 md:py-4 px-4 md:px-6 text-center">
//                           <div className="text-slate-600 text-sm sm:text-base">
//                             {stockValue}
//                           </div>
//                         </td>
//                         <td className="py-3 md:py-4 px-4 md:px-6 text-center">
//                           <span className={`inline-flex items-center justify-center w-20 md:w-24 px-2 md:px-3 py-1 md:py-2 rounded-full text-xs tracking-wide shadow-lg ${statusInfo.color}`}>
//                             {statusInfo.icon}
//                             {statusInfo.text}
//                           </span>
//                         </td>
//                         <td className="py-3 md:py-4 px-4 md:px-6 text-center">
//                           <button
//                             onClick={() => handleEditClick(f)}
//                             className="p-2 bg-gradient-to-br from-blue-500 to-blue-600 text-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110"
//                             title="Edit"
//                           >
//                             <FiEdit size={14} />
//                           </button>
//                         </td>
//                       </tr>
//                     );
//                   })
//                 ) : (
//                   <tr>
//                     <td colSpan="5" className="text-center py-12">
//                       <div className="flex flex-col items-center space-y-3">
//                         <div className="p-3 md:p-4 bg-gradient-to-br from-slate-200 to-slate-300 rounded-2xl shadow-inner">
//                           <FiLayers className="text-slate-500 text-lg md:text-xl" />
//                         </div>
//                         <p className="text-slate-500">No fabric types found</p>
//                         {stockFilter !== 'all' && (
//                           <button
//                             onClick={() => setStockFilter('all')}
//                             className="px-4 py-2 bg-gradient-to-br from-blue-500 to-blue-600 text-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300"
//                           >
//                             Show All Fabrics
//                           </button>
//                         )}
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {/* 3D Pagination */}
//           {filteredFabrics.length > itemsPerPage && (
//             <div className="flex flex-col md:flex-row items-center justify-between px-4 md:px-6 py-4 bg-gradient-to-r from-slate-50 to-slate-100/80 border-t border-slate-200/50 space-y-4 md:space-y-0">
//               <div className="text-sm text-slate-600">
//                 Showing {indexOfFirstItem + 1}–{Math.min(indexOfLastItem, filteredFabrics.length)} of{' '}
//                 {filteredFabrics.length}
//               </div>
//               <div className="flex items-center space-x-2">
//                 <button
//                   onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
//                   disabled={currentPage === 1}
//                   className="p-2 rounded-xl border border-slate-300 bg-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 disabled:opacity-40 disabled:hover:scale-100"
//                 >
//                   <FiChevronLeft size={14} />
//                 </button>

//                 {pageNumbers.map((page) => (
//                   <button
//                     key={page}
//                     onClick={() => setCurrentPage(page)}
//                     className={`px-2 md:px-3.5 py-1 md:py-1.5 rounded-xl border transition-all duration-300 transform hover:scale-105 text-sm ${
//                       currentPage === page
//                         ? 'bg-gradient-to-br from-blue-800 to-blue-700 text-white shadow-2xl scale-105 border-transparent'
//                         : 'bg-white text-slate-700 hover:bg-slate-50 border-slate-300 shadow-lg hover:shadow-xl'
//                     }`}
//                   >
//                     {page}
//                   </button>
//                 ))}

//                 <button
//                   onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
//                   disabled={currentPage === totalPages}
//                   className="p-2 rounded-xl border border-slate-300 bg-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 disabled:opacity-40 disabled:hover:scale-100"
//                 >
//                   <FiChevronRight size={14} />
//                 </button>
//               </div>
//             </div>
//           )}
//         </div>
//       )}

//       {/* Add Fabric Type Modal */}
//       {showModal && (
//         <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
//           <div className="relative w-full max-w-md">
//             <div className="absolute inset-0 bg-gradient-to-r from-blue-800 to-blue-700 rounded-3xl blur opacity-20 transform "></div>
//             <div className="relative bg-white/95 backdrop-blur-md rounded-3xl shadow-2xl border border-white/20 p-4 md:p-6">
//               <button
//                 onClick={() => {
//                   setShowModal(false);
//                   setFormError('');
//                   setFabricName('');
//                   setStock('');
//                 }}
//                 className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 rounded-xl hover:bg-slate-100/50 transition-colors duration-200"
//               >
//                 <FiX className="text-lg md:text-xl" />
//               </button>

//               <div className="flex items-center space-x-3 mb-4 md:mb-6">
//                 <div className="p-2 md:p-3 bg-gradient-to-br from-blue-800 to-blue-700 rounded-2xl shadow-lg">
//                   <FiPlus className="text-white text-base md:text-lg" />
//                 </div>
//                 <h2 className="text-lg md:text-xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">
//                   Add Fabric Type
//                 </h2>
//               </div>

//               {formError && (
//                 <div className="mb-4 md:mb-6 p-3 md:p-4 text-rose-700 bg-gradient-to-r from-rose-50 to-red-50 rounded-2xl border border-rose-200 shadow-inner text-sm">
//                   {formError}
//                 </div>
//               )}

//               <form onSubmit={handleAddFabric} className="space-y-4">
//                 <div>
//                   <label htmlFor="fabricName" className="block text-sm font-medium text-slate-700 mb-2">
//                     Fabric Name <span className="text-rose-500">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     id="fabricName"
//                     value={fabricName}
//                     onChange={(e) => {
//                       setFabricName(e.target.value);
//                       if (formError) setFormError('');
//                     }}
//                     className="w-full px-3 md:px-4 py-2 md:py-3 border-2 border-slate-200 rounded-2xl focus:ring-4 focus:ring-blue-200 focus:border-blue-400 bg-white/50 backdrop-blur-sm transition-all duration-300 shadow-inner text-sm md:text-base"
//                     placeholder="e.g., Denim, Cotton, Silk"
//                   />
//                 </div>

//                 <div>
//                   <label htmlFor="stock" className="block text-sm font-medium text-slate-700 mb-2">
//                     Stock Quantity <span className="text-rose-500"></span>
//                   </label>
//                   <input
//                     type="number"
//                     id="stock"
//                     value={stock}
//                     onChange={(e) => {
//                       setStock(e.target.value);
//                       if (formError) setFormError('');
//                     }}
//                     min="0"
//                     className="w-full px-3 md:px-4 py-2 md:py-3 border-2 border-slate-200 rounded-2xl focus:ring-4 focus:ring-blue-200 focus:border-blue-400 bg-white/50 backdrop-blur-sm transition-all duration-300 shadow-inner text-sm md:text-base"
//                     placeholder="e.g., 100"
//                   />
//                   <p className="text-xs text-slate-500 mt-1">Enter the initial stock quantity (0 or positive number)</p>
//                 </div>

//                 <div className="flex justify-end gap-3 md:gap-4 pt-4">
//                   <button
//                     type="button"
//                     onClick={() => {
//                       setShowModal(false);
//                       setFormError('');
//                       setFabricName('');
//                       setStock('');
//                     }}
//                     className="px-4 md:px-6 py-2 md:py-3 border-2 border-slate-300 rounded-2xl text-slate-700 font-medium hover:bg-slate-50 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl text-sm md:text-base"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     disabled={adding}
//                     className="px-4 md:px-6 py-2 md:py-3 bg-gradient-to-br from-blue-800 to-blue-700 text-white font-semibold rounded-2xl shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:hover:scale-100 text-sm md:text-base"
//                   >
//                     {adding ? (
//                       <div className="flex items-center space-x-2">
//                         <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
//                         <span>Saving...</span>
//                       </div>
//                     ) : (
//                       'Save Fabric Type'
//                     )}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Edit Fabric Type Modal */}
//       {showEditModal && editingFabric && (
//         <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
//           <div className="relative w-full max-w-md">
//             <div className="absolute inset-0 bg-gradient-to-r from-blue-800 to-blue-700 rounded-3xl blur opacity-20 transform "></div>
//             <div className="relative bg-white/95 backdrop-blur-md rounded-3xl shadow-2xl border border-white/20 p-4 md:p-6">
//               <button
//                 onClick={handleCancelEdit}
//                 className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 rounded-xl hover:bg-slate-100/50 transition-colors duration-200"
//               >
//                 <FiX className="text-lg md:text-xl" />
//               </button>

//               <div className="flex items-center space-x-3 mb-4 md:mb-6">
//                 <div className="p-2 md:p-3 bg-gradient-to-br from-blue-800 to-blue-700 rounded-2xl shadow-lg">
//                   <FiEdit className="text-white text-base md:text-lg" />
//                 </div>
//                 <h2 className="text-lg md:text-xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">
//                   Edit Fabric Type
//                 </h2>
//               </div>

//               <form onSubmit={handleSaveEdit} className="space-y-4">
//                 <div>
//                   <label htmlFor="editFabricName" className="block text-sm font-medium text-slate-700 mb-2">
//                     Fabric Name <span className="text-rose-500">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     id="editFabricName"
//                     value={editName}
//                     onChange={(e) => setEditName(e.target.value)}
//                     className="w-full px-3 md:px-4 py-2 md:py-3 border-2 border-slate-200 rounded-2xl focus:ring-4 focus:ring-blue-200 focus:border-blue-400 bg-white/50 backdrop-blur-sm transition-all duration-300 shadow-inner text-sm md:text-base"
//                     placeholder="e.g., Denim, Cotton, Silk"
//                   />
//                 </div>

//                 <div>
//                   <label htmlFor="editStock" className="block text-sm font-medium text-slate-700 mb-2">
//                     Stock Quantity <span className="text-rose-500">*</span>
//                   </label>
//                   <input
//                     type="number"
//                     id="editStock"
//                     value={editStock}
//                     onChange={(e) => setEditStock(e.target.value)}
//                     min="0"
//                     className="w-full px-3 md:px-4 py-2 md:py-3 border-2 border-slate-200 rounded-2xl focus:ring-4 focus:ring-blue-200 focus:border-blue-400 bg-white/50 backdrop-blur-sm transition-all duration-300 shadow-inner text-sm md:text-base"
//                     placeholder="e.g., 100"
//                   />
//                   <p className="text-xs text-slate-500 mt-1">Enter the stock quantity (0 or positive number)</p>
//                 </div>

//                 <div>
//                   <label htmlFor="editStatus" className="block text-sm font-medium text-slate-700 mb-2">
//                     Status <span className="text-rose-500">*</span>
//                   </label>
//                   <select
//                     id="editStatus"
//                     value={editStatus}
//                     onChange={(e) => setEditStatus(e.target.value)}
//                     className="w-full px-3 md:px-4 py-2 md:py-3 border-2 border-slate-200 rounded-2xl focus:ring-4 focus:ring-blue-200 focus:border-blue-400 bg-white/50 backdrop-blur-sm transition-all duration-300 shadow-inner text-sm md:text-base"
//                   >
//                     <option value="A">Active</option>
//                     <option value="I">Inactive</option>
//                   </select>
//                 </div>

//                 <div className="flex justify-end gap-3 md:gap-4 pt-4">
//                   <button
//                     type="button"
//                     onClick={handleCancelEdit}
//                     className="px-4 md:px-6 py-2 md:py-3 border-2 border-slate-300 rounded-2xl text-slate-700 font-medium hover:bg-slate-50 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl text-sm md:text-base"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     disabled={updating}
//                     className="px-4 md:px-6 py-2 md:py-3 bg-gradient-to-br from-blue-800 to-blue-700 text-white font-semibold rounded-2xl shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:hover:scale-100 text-sm md:text-base"
//                   >
//                     {updating ? (
//                       <div className="flex items-center space-x-2">
//                         <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
//                         <span>Updating...</span>
//                       </div>
//                     ) : (
//                       'Update Fabric Type'
//                     )}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default FabricTypes;





import React, { useState, useEffect } from 'react';
import {
  FiPlus,
  FiSearch,
  FiX,
  FiChevronLeft,
  FiChevronRight,
  FiCheckCircle,
  FiAlertCircle,
  FiEdit,
  FiSave,
  FiActivity,
  FiArchive,
  FiLayers,
  FiPackage,
  FiFilter
} from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import { GetAllFabricType, AddFabricType, UpdateFabricType, GetAllInactiveFabricType } from '../actions/fabricTypeAction';

function FabricTypes() {
  const dispatch = useDispatch();

  // Redux selectors
  const fabricTypeList = useSelector((state) => state.fabricTypeList || {});
  const { loading, responseBody: activeFabrics = [] } = fabricTypeList;

  const fabricTypeAdd = useSelector((state) => state.fabricTypeAdd || {});
  const { loading: adding, error: addError, msg: addMsg } = fabricTypeAdd;

  const fabricTypeUpdate = useSelector((state) => state.fabricTypeUpdate || {});
  const { loading: updating, error: updateError, msg: updateMsg } = fabricTypeUpdate;

  const InactiveFabricTypeData = useSelector((state) => state.InactiveFabricTypeData || {});
  const { loading: loadingInactive, responseBody: inactiveFabrics = [] } = InactiveFabricTypeData;

  // State management
  const [search, setSearch] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [fabricName, setFabricName] = useState('');
  const [stock, setStock] = useState('');
  const [formError, setFormError] = useState('');
  const [notification, setNotification] = useState(null);
  
  // State for editing
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState('');
  const [editStock, setEditStock] = useState('');
  const [editStatus, setEditStatus] = useState('A');
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingFabric, setEditingFabric] = useState(null);

  // Stock filter state
  const [stockFilter, setStockFilter] = useState('all'); // 'all', 'out', 'low', 'good'

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(8);

  // Fetch both active and inactive fabrics
  useEffect(() => {
    dispatch(GetAllFabricType());
    dispatch(GetAllInactiveFabricType({}));
  }, [dispatch]);

  // Show success/error toast after add or update - WITH PROPER CLEANUP
  useEffect(() => {
    let timer;
    
    if (!adding && (addMsg || addError)) {
      if (addError) {
        setNotification({ type: 'error', message: addError || 'Failed to add fabric type!' });
      } else if (addMsg) {
        setNotification({ type: 'success', message: addMsg || 'Fabric type added successfully!' });
        setShowModal(false);
        setFabricName('');
        setStock('');
        dispatch(GetAllFabricType());
        dispatch(GetAllInactiveFabricType({}));
      }
      timer = setTimeout(() => setNotification(null), 3000);
    }
    
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [addMsg, addError, adding, dispatch]);

  useEffect(() => {
    let timer;
    
    if (!updating && (updateMsg || updateError)) {
      if (updateError) {
        setNotification({ type: 'error', message: updateError || 'Failed to update fabric type!' });
      } else if (updateMsg) {
        setNotification({ type: 'success', message: updateMsg || 'Fabric type updated successfully!' });
        setShowEditModal(false);
        setEditingId(null);
        setEditName('');
        setEditStock('');
        setEditStatus('A');
        setEditingFabric(null);
        dispatch(GetAllFabricType());
        dispatch(GetAllInactiveFabricType({}));
      }
      timer = setTimeout(() => setNotification(null), 3000);
    }
    
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [updateMsg, updateError, updating, dispatch]);

  // Cleanup notifications when component unmounts or when dependencies change
  useEffect(() => {
    return () => {
      setNotification(null);
    };
  }, []);

  // Reset notification when search or filters change (user interacts with the page)
  useEffect(() => {
    setNotification(null);
  }, [search, stockFilter, currentPage]);

  // Combine active and inactive fabrics for display and sort in descending order
  const allFabrics = [
    ...(Array.isArray(activeFabrics) ? activeFabrics.map(fab => ({ ...fab, status: 'A' })) : []),
    ...(Array.isArray(inactiveFabrics) ? inactiveFabrics.map(fab => ({ ...fab, status: 'I' })) : [])
  ].sort((a, b) => {
    // Sort by FabricTypeId in descending order (newest first)
    return (b.FabricTypeId || 0) - (a.FabricTypeId || 0);
  });

  // Get stock status and category for filtering
  const getStockCategory = (stock) => {
    const stockValue = parseInt(stock) || 0;
    
    if (stockValue === 0) {
      return 'out';
    } else if (stockValue <= 10) {
      return 'low';
    } else {
      return 'good';
    }
  };

  // Handle add fabric type with duplicate check
  const handleAddFabric = (e) => {
    e.preventDefault();
    const name = fabricName.trim();
    if (!name) {
      setFormError('Please enter a fabric name');
      return;
    }

    const exists = allFabrics.some(
      (f) => f.FabricTypeName.toLowerCase() === name.toLowerCase()
    );
    if (exists) {
      setNotification({ type: 'error', message: 'Fabric type already exists!' });
      setTimeout(() => setNotification(null), 3000);
      return;
    }

    // Validate stock
    const stockValue = parseInt(stock);
    if (isNaN(stockValue) || stockValue < 0) {
      setFormError('Please enter a valid stock quantity (0 or positive number)');
      return;
    }

    setFormError('');
    dispatch(AddFabricType({ 
      FabricTypeName: name,
      Stock: stockValue
    }));
  };

  // Handle edit fabric type - Open modal
  const handleEditClick = (fabric) => {
    setEditingFabric(fabric);
    setEditName(fabric.FabricTypeName);
    setEditStock(fabric.Stock || '');
    setEditStatus(fabric.status || fabric.Status || 'A');
    setShowEditModal(true);
  };

  // Handle save edited fabric type
  const handleSaveEdit = (e) => {
    e.preventDefault();
    
    if (!editingFabric) return;

    const name = editName.trim();
    if (!name) {
      setNotification({ type: 'error', message: 'Please enter a fabric name' });
      setTimeout(() => setNotification(null), 3000);
      return;
    }

    // Validate stock
    const stockValue = parseInt(editStock);
    if (isNaN(stockValue) || stockValue < 0) {
      setNotification({ type: 'error', message: 'Please enter a valid stock quantity (0 or positive number)' });
      setTimeout(() => setNotification(null), 3000);
      return;
    }

    const exists = allFabrics.some(
      (f) => 
        f.FabricTypeId !== editingFabric.FabricTypeId && 
        f.FabricTypeName.toLowerCase() === name.toLowerCase()
    );
    if (exists) {
      setNotification({ type: 'error', message: 'Fabric type already exists!' });
      setTimeout(() => setNotification(null), 3000);
      return;
    }

    const updateData = {
      FabricTypeId: editingFabric.FabricTypeId,
      FabricTypeName: name,
      Stock: stockValue,
      Status: editStatus
    };

    console.log('Sending update data:', updateData); // Debug log
    dispatch(UpdateFabricType(updateData));
  };

  // Handle cancel edit
  const handleCancelEdit = () => {
    setShowEditModal(false);
    setEditingFabric(null);
    setEditName('');
    setEditStock('');
    setEditStatus('A');
  };

  // Get status display text and color
  const getStatusInfo = (fabric) => {
    const status = fabric.status || fabric.Status;
    const isActive = status === 'A' || !status;
    
    if (isActive) {
      return { 
        text: 'Active', 
        color: 'bg-gradient-to-br from-green-500 to-green-600 text-white shadow-lg shadow-green-200/50',
        icon: <FiCheckCircle className="mr-1" size={12} />
      };
    } else {
      return { 
        text: 'Inactive', 
        color: 'bg-gradient-to-br from-slate-500 to-slate-600 text-white shadow-lg shadow-slate-200/50',
        icon: <FiArchive className="mr-1" size={12} />
      };
    }
  };

  // Get row styling based on status
  const getRowClass = (fabric) => {
    const status = fabric.status || fabric.Status;
    const isActive = status === 'A' || !status;
    
    return isActive 
      ? 'hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 bg-gradient-to-r from-white to-green-50/30 border-l-4 border-l-green-400' 
      : 'hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 bg-gradient-to-r from-white to-slate-50/30 border-l-4 border-l-slate-300';
  };

  // Filter fabrics based on search and stock filter
  const filteredFabrics = allFabrics.filter((f) => {
    const matchesSearch = (f.FabricTypeName || '').toLowerCase().includes(search.toLowerCase());
    const stockCategory = getStockCategory(f.Stock);
    
    if (stockFilter === 'all') {
      return matchesSearch;
    } else {
      return matchesSearch && stockCategory === stockFilter;
    }
  });

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentFabrics = filteredFabrics.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredFabrics.length / itemsPerPage);

  // Pagination 3-page sliding window
  const pageNumbers = [];
  const maxPageButtons = 3;
  let startPage = Math.max(1, currentPage - 1);
  let endPage = Math.min(totalPages, startPage + maxPageButtons - 1);
  if (endPage - startPage + 1 < maxPageButtons) {
    startPage = Math.max(1, endPage - maxPageButtons + 1);
  }
  for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);

  // Get count by stock category
  const stockCounts = {
    all: allFabrics.length,
    out: allFabrics.filter(f => getStockCategory(f.Stock) === 'out').length,
    low: allFabrics.filter(f => getStockCategory(f.Stock) === 'low').length,
    good: allFabrics.filter(f => getStockCategory(f.Stock) === 'good').length,
  };

  // Loading state
  const isLoading = loading || loadingInactive;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-100/30 p-4 md:p-6 relative overflow-hidden">
      {/* 3D Background Elements */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-gradient-to-r from-blue-400/20 to-purple-500/20 rounded-full -translate-x-1/2 -translate-y-1/2 opacity-40 blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-r from-blue-400/20 to-cyan-500/20 rounded-full translate-x-1/3 translate-y-1/3 opacity-40 blur-3xl"></div>
      
      {/* 3D Notification */}
      {notification && (
        <div
          className={`fixed top-6 right-6 z-[100] p-4 rounded-2xl shadow-2xl flex items-center transition-all duration-500 transform backdrop-blur-none ${
            notification.type === 'success' 
              ? 'bg-gradient-to-r from-green-500 to-green-600 text-white shadow-green-200/50 border-l-4 border-l-green-400' 
              : notification.type === 'error'
              ? 'bg-gradient-to-r from-rose-500 to-red-600 text-white shadow-rose-200/50 border-l-4 border-l-rose-400'
              : 'bg-gradient-to-r from-blue-500 to-cyan-600 text-white shadow-blue-200/50 border-l-4 border-l-blue-400'
          } animate-bounce-in`}
          role="alert"
        >
          <div className="bg-white/20 p-2 rounded-full mr-3 backdrop-blur-sm">
            {notification.type === 'success' ? (
              <FiCheckCircle className="text-white" size={18} />
            ) : notification.type === 'error' ? (
              <FiAlertCircle className="text-white" size={18} />
            ) : (
              <FiActivity className="text-white" size={18} />
            )}
          </div>
          <span className="font-semibold text-sm">{notification.message}</span>
        </div>
      )}

      {/* Header Section with 3D Effect */}
      <div className="relative z-10 mb-6 md:mb-8">
        <div className="flex items-center space-x-4 mb-3">
          <div className="p-3 md:p-4 bg-gradient-to-br from-blue-800 to-blue-900 rounded-2xl shadow-2xl transform ">
            <FiLayers className="text-white text-lg md:text-xl" />
          </div>
          <div className="transform ">
            <h1 className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">
              Fabric Types
            </h1>
            <p className="text-slate-600 mt-1 text-sm md:text-base">Manage your fabric inventory</p>
          </div>
        </div>
      </div>

      {/* 3D Stats Cards - Added Out of Stock card */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-6 mb-6 md:mb-8 relative z-10">
        <div className="group relative">
          <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-blue-800 rounded-3xl blur opacity-20 group-hover:opacity-30 transition duration-300 transform group-hover:scale-105"></div>
          <div className="relative bg-white/90 backdrop-blur-sm p-4 md:p-6 rounded-3xl shadow-2xl border border-white/20 transform transition duration-300 group-hover:-translate-y-2 group-hover:shadow-3xl">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-slate-600 text-sm font-medium">Total Types</p>
                <p className="text-xl md:text-2xl font-bold text-slate-800">
                  {allFabrics.length}
                </p>
              </div>
              <div className="p-2 md:p-3 bg-gradient-to-br from-blue-700 to-blue-800 rounded-2xl shadow-lg">
                <FiLayers className="text-white text-base md:text-lg" />
              </div>
            </div>
          </div>
        </div>

        <div className="group relative">
          <div className="absolute inset-0 bg-gradient-to-r from-red-500 to-red-700 rounded-3xl blur opacity-20 group-hover:opacity-30 transition duration-300 transform group-hover:scale-105"></div>
          <div className="relative bg-white/90 backdrop-blur-sm p-4 md:p-6 rounded-3xl shadow-2xl border border-white/20 transform transition duration-300 group-hover:-translate-y-2 group-hover:shadow-3xl">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-slate-600 text-sm font-medium">Out of Stock</p>
                <p className="text-xl md:text-2xl font-bold text-slate-800">
                  {stockCounts.out}
                </p>
              </div>
              <div className="p-2 md:p-3 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl shadow-lg">
                <FiAlertCircle className="text-white text-base md:text-lg" />
              </div>
            </div>
          </div>
        </div>

        <div className="group relative">
          <div className="absolute inset-0 bg-gradient-to-r from-yellow-500 to-yellow-600 rounded-3xl blur opacity-20 group-hover:opacity-30 transition duration-300 transform group-hover:scale-105"></div>
          <div className="relative bg-white/90 backdrop-blur-sm p-4 md:p-6 rounded-3xl shadow-2xl border border-white/20 transform transition duration-300 group-hover:-translate-y-2 group-hover:shadow-3xl">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-slate-600 text-sm font-medium">Low Stock</p>
                <p className="text-xl md:text-2xl font-bold text-slate-800">
                  {stockCounts.low}
                </p>
              </div>
              <div className="p-2 md:p-3 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl shadow-lg">
                <FiAlertCircle className="text-white text-base md:text-lg" />
              </div>
            </div>
          </div>
        </div>

        <div className="group relative">
          <div className="absolute inset-0 bg-gradient-to-r from-green-500 to-green-700 rounded-3xl blur opacity-20 group-hover:opacity-30 transition duration-300 transform group-hover:scale-105"></div>
          <div className="relative bg-white/90 backdrop-blur-sm p-4 md:p-6 rounded-3xl shadow-2xl border border-white/20 transform transition duration-300 group-hover:-translate-y-2 group-hover:shadow-3xl">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-slate-600 text-sm font-medium">Good Stock</p>
                <p className="text-xl md:text-2xl font-bold text-slate-800">
                  {stockCounts.good}
                </p>
              </div>
              <div className="p-2 md:p-3 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl shadow-lg">
                <FiCheckCircle className="text-white text-base md:text-lg" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Search + Filter + Add button - 3D Design */}
      <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-4 mb-6 md:mb-8">
        <div className="flex flex-col md:flex-row flex-grow space-y-4 md:space-y-0 md:space-x-4 w-full">
          <div className="relative flex-grow group">
            <div className="absolute inset-0 bg-gradient-to-r from-slate-400 to-slate-600 rounded-2xl blur opacity-20 group-hover:opacity-30 transition duration-300 transform group-hover:scale-105"></div>
            <input
              type="text"
              placeholder="Search fabric types..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="relative w-full pl-10 sm:pl-12 pr-4 sm:pr-6 py-2.5 sm:py-3.5 border-0 bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl focus:outline-none focus:ring-2 sm:focus:ring-4 focus:ring-blue-200 text-slate-700 placeholder-slate-500 font-medium transition-all duration-300 text-sm sm:text-base"
              disabled={isLoading}
            />
            <FiSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 z-10" size={18} />
          </div>
          
          {/* Stock Filter */}
          <div className="relative group">
            <div className="absolute inset-0 bg-gradient-to-r from-slate-500 to-slate-700 rounded-2xl blur opacity-20 group-hover:opacity-30 transition duration-300 transform group-hover:scale-105"></div>
            <div className="relative flex items-center bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl px-3 py-2.5 sm:py-3.5">
              <FiFilter className="text-slate-400 mr-2" size={16} />
              <select
                value={stockFilter}
                onChange={(e) => setStockFilter(e.target.value)}
                className="bg-transparent border-0 focus:outline-none focus:ring-0 text-slate-700 font-medium text-sm sm:text-base appearance-none cursor-pointer"
              >
                <option value="all">All Stock</option>
                <option value="out">Out of Stock</option>
                <option value="low">Low Stock (1-10)</option>
                <option value="good">Good Stock (11+)</option>
              </select>
            </div>
          </div>

          <button
            onClick={() => setShowModal(true)}
            className="relative group bg-gradient-to-br from-blue-800 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold px-6 py-3 md:py-3.5 rounded-2xl flex items-center justify-center shadow-2xl transition-all duration-300 transform hover:scale-105 hover:shadow-3xl active:scale-95 w-full md:w-auto"
          >
            <div className="absolute inset-0 bg-white/10 rounded-2xl transform group-hover:scale-110 transition duration-300"></div>
            <FiPlus className="mr-2 relative z-10" size={18} /> 
            <span className="relative z-10">Add Fabric Type</span>
          </button>
        </div>
      </div>

      {/* 3D Table */}
      {isLoading ? (
        <div className="relative z-10 text-center py-12">
          <div className="inline-flex items-center space-x-3 bg-white/90 backdrop-blur-sm p-6 rounded-2xl shadow-2xl border border-white/20">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-800"></div>
            <span className="text-slate-700">Loading fabric types...</span>
          </div>
        </div>
      ) : (
        <div className="relative z-10 overflow-hidden rounded-3xl shadow-2xl border border-white/20 bg-white/90 backdrop-blur-sm">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[700px]">
              <thead>
                <tr className="bg-gradient-to-r from-slate-50 to-slate-100/80 border-b border-slate-200/50">
                  <th className="py-3 md:py-4 px-4 md:px-6 text-left text-slate-700 font-semibold text-xs md:text-sm uppercase tracking-wider">Fabric ID</th>
                  <th className="py-3 md:py-4 px-4 md:px-6 text-left text-slate-700 font-semibold text-xs md:text-sm uppercase tracking-wider">Fabric Type</th>
                  <th className="py-3 md:py-4 px-4 md:px-6 text-center text-slate-700 font-semibold text-xs md:text-sm uppercase tracking-wider">Stock</th>
                  <th className="py-3 md:py-4 px-4 md:px-6 text-center text-slate-700 font-semibold text-xs md:text-sm uppercase tracking-wider">Status</th>
                  <th className="py-3 md:py-4 px-4 md:px-6 text-center text-slate-700 font-semibold text-xs md:text-sm uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200/50">
                {currentFabrics.length > 0 ? (
                  currentFabrics.map((f, i) => {
                    const statusInfo = getStatusInfo(f);
                    const rowClass = getRowClass(f);
                    const stockValue = parseInt(f.Stock) || 0;
                    
                    return (
                      <tr key={f.FabricTypeId || i} className={`${rowClass} group`}>
                        <td className="px-3 sm:px-4 md:px-6 py-3 sm:py-4 text-slate-600 text-sm sm:text-base max-w-[200px] truncate">
                          {f.FabricTypeId || 'N/A'}
                        </td>
                        <td className="px-3 sm:px-4 md:px-6 py-3 sm:py-4 text-slate-600 text-sm sm:text-base max-w-[200px] truncate">
                          <div className="flex items-center">
                            <span className="text-slate-800 text-sm md:text-base">
                              {f.FabricTypeName}
                            </span>
                          </div>
                        </td>
                        <td className="py-3 md:py-4 px-4 md:px-6 text-center">
                          <div className="text-slate-600 text-sm sm:text-base">
                            {stockValue}
                          </div>
                        </td>
                        <td className="py-3 md:py-4 px-4 md:px-6 text-center">
                          <span className={`inline-flex items-center justify-center w-20 md:w-24 px-2 md:px-3 py-1 md:py-2 rounded-full text-xs tracking-wide shadow-lg ${statusInfo.color}`}>
                            {statusInfo.icon}
                            {statusInfo.text}
                          </span>
                        </td>
                        <td className="py-3 md:py-4 px-4 md:px-6 text-center">
                          <button
                            onClick={() => handleEditClick(f)}
                            className="p-2 bg-gradient-to-br from-blue-500 to-blue-600 text-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110"
                            title="Edit"
                          >
                            <FiEdit size={14} />
                          </button>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center py-12">
                      <div className="flex flex-col items-center space-y-3">
                        <div className="p-3 md:p-4 bg-gradient-to-br from-slate-200 to-slate-300 rounded-2xl shadow-inner">
                          <FiLayers className="text-slate-500 text-lg md:text-xl" />
                        </div>
                        <p className="text-slate-500">No fabric types found</p>
                        {stockFilter !== 'all' && (
                          <button
                            onClick={() => setStockFilter('all')}
                            className="px-4 py-2 bg-gradient-to-br from-blue-500 to-blue-600 text-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300"
                          >
                            Show All Fabrics
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* 3D Pagination */}
          {filteredFabrics.length > itemsPerPage && (
            <div className="flex flex-col md:flex-row items-center justify-between px-4 md:px-6 py-4 bg-gradient-to-r from-slate-50 to-slate-100/80 border-t border-slate-200/50 space-y-4 md:space-y-0">
              <div className="text-sm text-slate-600">
                Showing {indexOfFirstItem + 1}–{Math.min(indexOfLastItem, filteredFabrics.length)} of{' '}
                {filteredFabrics.length}
              </div>
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                  disabled={currentPage === 1}
                  className="p-2 rounded-xl border border-slate-300 bg-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 disabled:opacity-40 disabled:hover:scale-100"
                >
                  <FiChevronLeft size={14} />
                </button>

                {pageNumbers.map((page) => (
                  <button
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    className={`px-2 md:px-3.5 py-1 md:py-1.5 rounded-xl border transition-all duration-300 transform hover:scale-105 text-sm ${
                      currentPage === page
                        ? 'bg-gradient-to-br from-blue-800 to-blue-700 text-white shadow-2xl scale-105 border-transparent'
                        : 'bg-white text-slate-700 hover:bg-slate-50 border-slate-300 shadow-lg hover:shadow-xl'
                    }`}
                  >
                    {page}
                  </button>
                ))}

                <button
                  onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                  disabled={currentPage === totalPages}
                  className="p-2 rounded-xl border border-slate-300 bg-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 disabled:opacity-40 disabled:hover:scale-100"
                >
                  <FiChevronRight size={14} />
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Add Fabric Type Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="relative w-full max-w-md">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-800 to-blue-700 rounded-3xl blur opacity-20 transform "></div>
            <div className="relative bg-white/95 backdrop-blur-md rounded-3xl shadow-2xl border border-white/20 p-4 md:p-6">
              <button
                onClick={() => {
                  setShowModal(false);
                  setFormError('');
                  setFabricName('');
                  setStock('');
                }}
                className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 rounded-xl hover:bg-slate-100/50 transition-colors duration-200"
              >
                <FiX className="text-lg md:text-xl" />
              </button>

              <div className="flex items-center space-x-3 mb-4 md:mb-6">
                <div className="p-2 md:p-3 bg-gradient-to-br from-blue-800 to-blue-700 rounded-2xl shadow-lg">
                  <FiPlus className="text-white text-base md:text-lg" />
                </div>
                <h2 className="text-lg md:text-xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">
                  Add Fabric Type
                </h2>
              </div>

              {formError && (
                <div className="mb-4 md:mb-6 p-3 md:p-4 text-rose-700 bg-gradient-to-r from-rose-50 to-red-50 rounded-2xl border border-rose-200 shadow-inner text-sm">
                  {formError}
                </div>
              )}

              <form onSubmit={handleAddFabric} className="space-y-4">
                <div>
                  <label htmlFor="fabricName" className="block text-sm font-medium text-slate-700 mb-2">
                    Fabric Name <span className="text-rose-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="fabricName"
                    value={fabricName}
                    onChange={(e) => {
                      setFabricName(e.target.value);
                      if (formError) setFormError('');
                    }}
                    className="w-full px-3 md:px-4 py-2 md:py-3 border-2 border-slate-200 rounded-2xl focus:ring-4 focus:ring-blue-200 focus:border-blue-400 bg-white/50 backdrop-blur-sm transition-all duration-300 shadow-inner text-sm md:text-base"
                    placeholder="e.g., Denim, Cotton, Silk"
                  />
                </div>

                <div>
                  <label htmlFor="stock" className="block text-sm font-medium text-slate-700 mb-2">
                    Stock Quantity <span className="text-rose-500"></span>
                  </label>
                  <input
                    type="number"
                    id="stock"
                    value={stock}
                    onChange={(e) => {
                      setStock(e.target.value);
                      if (formError) setFormError('');
                    }}
                    min="0"
                    className="w-full px-3 md:px-4 py-2 md:py-3 border-2 border-slate-200 rounded-2xl focus:ring-4 focus:ring-blue-200 focus:border-blue-400 bg-white/50 backdrop-blur-sm transition-all duration-300 shadow-inner text-sm md:text-base"
                    placeholder="e.g., 100"
                  />
                  <p className="text-xs text-slate-500 mt-1">Enter the initial stock quantity (0 or positive number)</p>
                </div>

                <div className="flex justify-end gap-3 md:gap-4 pt-4">
                  <button
                    type="button"
                    onClick={() => {
                      setShowModal(false);
                      setFormError('');
                      setFabricName('');
                      setStock('');
                    }}
                    className="px-4 md:px-6 py-2 md:py-3 border-2 border-slate-300 rounded-2xl text-slate-700 font-medium hover:bg-slate-50 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl text-sm md:text-base"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={adding}
                    className="px-4 md:px-6 py-2 md:py-3 bg-gradient-to-br from-blue-800 to-blue-700 text-white font-semibold rounded-2xl shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:hover:scale-100 text-sm md:text-base"
                  >
                    {adding ? (
                      <div className="flex items-center space-x-2">
                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                        <span>Saving...</span>
                      </div>
                    ) : (
                      'Save Fabric Type'
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Edit Fabric Type Modal */}
      {showEditModal && editingFabric && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="relative w-full max-w-md">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-800 to-blue-700 rounded-3xl blur opacity-20 transform "></div>
            <div className="relative bg-white/95 backdrop-blur-md rounded-3xl shadow-2xl border border-white/20 p-4 md:p-6">
              <button
                onClick={handleCancelEdit}
                className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 rounded-xl hover:bg-slate-100/50 transition-colors duration-200"
              >
                <FiX className="text-lg md:text-xl" />
              </button>

              <div className="flex items-center space-x-3 mb-4 md:mb-6">
                <div className="p-2 md:p-3 bg-gradient-to-br from-blue-800 to-blue-700 rounded-2xl shadow-lg">
                  <FiEdit className="text-white text-base md:text-lg" />
                </div>
                <h2 className="text-lg md:text-xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">
                  Edit Fabric Type
                </h2>
              </div>

              <form onSubmit={handleSaveEdit} className="space-y-4">
                <div>
                  <label htmlFor="editFabricName" className="block text-sm font-medium text-slate-700 mb-2">
                    Fabric Name <span className="text-rose-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="editFabricName"
                    value={editName}
                    onChange={(e) => setEditName(e.target.value)}
                    className="w-full px-3 md:px-4 py-2 md:py-3 border-2 border-slate-200 rounded-2xl focus:ring-4 focus:ring-blue-200 focus:border-blue-400 bg-white/50 backdrop-blur-sm transition-all duration-300 shadow-inner text-sm md:text-base"
                    placeholder="e.g., Denim, Cotton, Silk"
                  />
                </div>

                <div>
                  <label htmlFor="editStock" className="block text-sm font-medium text-slate-700 mb-2">
                    Stock Quantity <span className="text-rose-500">*</span>
                  </label>
                  <input
                    type="number"
                    id="editStock"
                    value={editStock}
                    onChange={(e) => setEditStock(e.target.value)}
                    min="0"
                    className="w-full px-3 md:px-4 py-2 md:py-3 border-2 border-slate-200 rounded-2xl focus:ring-4 focus:ring-blue-200 focus:border-blue-400 bg-white/50 backdrop-blur-sm transition-all duration-300 shadow-inner text-sm md:text-base"
                    placeholder="e.g., 100"
                  />
                  <p className="text-xs text-slate-500 mt-1">Enter the stock quantity (0 or positive number)</p>
                </div>

                <div>
                  <label htmlFor="editStatus" className="block text-sm font-medium text-slate-700 mb-2">
                    Status <span className="text-rose-500">*</span>
                  </label>
                  <select
                    id="editStatus"
                    value={editStatus}
                    onChange={(e) => setEditStatus(e.target.value)}
                    className="w-full px-3 md:px-4 py-2 md:py-3 border-2 border-slate-200 rounded-2xl focus:ring-4 focus:ring-blue-200 focus:border-blue-400 bg-white/50 backdrop-blur-sm transition-all duration-300 shadow-inner text-sm md:text-base"
                  >
                    <option value="A">Active</option>
                    <option value="I">Inactive</option>
                  </select>
                </div>

                <div className="flex justify-end gap-3 md:gap-4 pt-4">
                  <button
                    type="button"
                    onClick={handleCancelEdit}
                    className="px-4 md:px-6 py-2 md:py-3 border-2 border-slate-300 rounded-2xl text-slate-700 font-medium hover:bg-slate-50 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl text-sm md:text-base"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={updating}
                    className="px-4 md:px-6 py-2 md:py-3 bg-gradient-to-br from-blue-800 to-blue-700 text-white font-semibold rounded-2xl shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:hover:scale-100 text-sm md:text-base"
                  >
                    {updating ? (
                      <div className="flex items-center space-x-2">
                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                        <span>Updating...</span>
                      </div>
                    ) : (
                      'Update Fabric Type'
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default FabricTypes;